<template>
  <div class="product_warp">
    <div class="product_banner_warp">
      <img :src="activeImgUrl" alt="" class="product_banner">
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('product.Computer')" name="first">
        <ul class="look_bug">
          <li class="look_bug_item bg_w">
            <div class="look_bug_img">
              <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353385411.jpeg" alt="">
              <!--<video src="http://bu.dressplus.cn/cdn/media/reports/img/153052353501121.mp4" autoplay='autoplay'></video>-->
            </div>
            <div class="look_bug_text">
              <div>
                <p class="look_bug_title">
                  {{$t('product.Depth')}}
                </p>
                <p class="look_bug_p">
                  {{$t('product.depiction')}}
                </p>
              </div>
            </div>
          </li>
          <li class="look_bug_item bg_g">
            <div class="look_bug_img">
              <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353396912.jpeg" alt="">
            </div>
            <div class="look_bug_text">
              <div>
                <p class="look_bug_title">
                  {{$t('product.Recommendation')}}
                </p>
                <p class="look_bug_p">
                  {{$t('product.behaviour')}}
                </p>
              </div>
            </div>
          </li>
          <li class="look_bug_item bg_w">
            <div class="look_bug_img">
              <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353406513.jpeg" alt="">
            </div>
            <div class="look_bug_text">
              <div>
                <p class="look_bug_title">
                  {{$t('product.Analysis')}}
                </p>
                <p class="look_bug_p">
                  {{$t('product.massive')}}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane :label="$t('product.Image')" name="second">
        <ul class="look_bug">
        <li class="look_bug_item bg_w">
          <div class="look_bug_img">
            <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353416614.jpeg" alt="">
          </div>
          <div class="look_bug_text">
            <div>
              <p class="look_bug_title">
                {{$t('product.Contour')}}
              </p>
              <p class="look_bug_p">
                {{$t('product.characteristics')}}
              </p>
            </div>
          </div>
        </li>
        <li class="look_bug_item bg_g">
          <div class="look_bug_img">
            <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353428115.jpeg" alt="">
          </div>
          <div class="look_bug_text">
            <div>
              <p class="look_bug_title">
                {{$t('product.Target')}}
              </p>
              <p class="look_bug_p">
                {{$t('product.adopts')}}
              </p>
            </div>
          </div>
        </li>
        <li class="look_bug_item bg_w">
          <div class="look_bug_img">
            <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353439916.jpeg" alt="">
          </div>
          <div class="look_bug_text">
            <div>
              <p class="look_bug_title">
                {{$t('product.General')}}
              </p>
              <p class="look_bug_p">
                {{$t('product.supports')}}
              </p>
            </div>
          </div>
        </li>
      </ul>
      </el-tab-pane>
      <el-tab-pane :label="$t('product.Face')" name="third">
        <ul class="look_bug">
          <li class="look_bug_item bg_w">
            <div class="look_bug_img">
              <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353450617.jpeg" alt="">
            </div>
            <div class="look_bug_text">
              <div>
                <p class="look_bug_title">
                  {{$t('product.FaceRecognition')}}
                </p>
                <p class="look_bug_p">
                  {{$t('product.RealTime')}}
                </p>
              </div>
            </div>
          </li>
          <li class="look_bug_item bg_g">
            <div class="look_bug_img">
              <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353471418.jpeg" alt="">
            </div>
            <div class="look_bug_text">
              <div>
                <p class="look_bug_title">
                  {{$t('product.Characteristic')}}
                </p>
                <p class="look_bug_p">
                  {{$t('product.identifies')}}
                </p>
              </div>
            </div>
          </li>
          <li class="look_bug_item bg_w">
            <div class="look_bug_img">
              <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353480519.jpeg" alt="">
            </div>
            <div class="look_bug_text">
              <div>
                <p class="look_bug_title">
                  {{$t('product.FaceComparison')}}
                </p>
                <p class="look_bug_p">
                  {{$t('product.Facial')}}
                </p>
              </div>
            </div>
          </li>
          <li class="look_bug_item bg_g">
            <div class="look_bug_img">
              <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353490520.jpeg" alt="">
            </div>
            <div class="look_bug_text">
              <div>
                <p class="look_bug_title">
                  {{$t('product.Points')}}
                </p>
                <p class="look_bug_p">
                  {{$t('product.Supports')}}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
	import bus from '../utils/bus'
  export default {
		data(){
			return{
				activeName:'first',
				activeImgUrl:'http://bu.dressplus.cn/cdn/media/reports/img/15305235335198.jpeg',
      }
    },
    created(){
     // window.addEventListener('scroll', this.handleScroll2)
	    if (this.$route.query.activeName) {
		    this.activeName = this.$route.query.activeName;
	    }
    },
	  mounted(){
		  bus.$emit('customEvent','product');
	  },
    watch:{
	    activeName(newval,oldval){
		    if (newval === 'first') {
			    this.activeImgUrl = 'http://bu.dressplus.cn/cdn/media/reports/img/15305235335198.jpeg'
		    }else if (newval === 'second'){
			    this.activeImgUrl = 'http://bu.dressplus.cn/cdn/media/reports/img/15305235336039.jpeg'
		    } else if (newval === 'third'){
			    this.activeImgUrl = 'http://bu.dressplus.cn/cdn/media/reports/img/153052353375210.jpeg'
		    }
	    }
    },
    methods:{
	    handleClick(tab, event) {
		    /*if (tab.name === 'first') {
		    	this.activeImgUrl = '../../static/img/about_img01.jpg'
        }else if (tab.name === 'second'){
			    this.activeImgUrl = '../../static/img/about_img02.jpg'
		    } else if (tab.name === 'third'){
			    this.activeImgUrl = '../../static/img/footer-btn.jpg'
		    }*/
	    }
    },
    destroyed(){
     // window.removeEventListener('scroll', this.handleScroll2)
    }
  }
</script>

<style>
  @media screen and (min-width: 768px){
    .product_warp{

    }
    .el-tabs__header{
      margin: 0;
    }
    .el-tabs__nav{
      width: 100%;
    }
    .el-tabs__item{
      height: 70px;
      line-height: 70px;
      width: 33.333%;
      text-align: center;
      background: #0b0b0b;
      opacity: 0.64;
      color: #fff;
    }
    .el-tabs__item.is-active{
      background: #008cee;
      color: #fff;
      opacity: 1;
    }
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs__item:hover {
      color: #fff;
    }
    .product_banner_warp{
      overflow: hidden;
      margin-bottom: -70px;
    }
    .product_banner{
      vertical-align: middle;
      width: 100%;
    }
    /*背景色*/
    .bg_g{
      background-color: #fff;
    }
    .bg_g{
      background-color: rgb(247,247,247);
    }
    /*边看边买*/
    .look_bug{

    }
    .look_bug_item{
      width:100%;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 50px 0;
      display: flex;
      justify-content: center;
    }
    .look_bug_img{
      width: 38%;
      text-align: center;
      min-width: 460px;
    }
    .look_bug_img img{
      width: 90%;
      vertical-align: middle;
    }
    .look_bug_img video{
      width: 90%;
      vertical-align: middle;
    }
    .look_bug_text{
      width: 22%;
      display: flex;
      align-items: center;
      min-width: 264px;
    }
    .look_bug_title{
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    .look_bug_p{
      line-height: 30px;
      font-size: 15px;
    }
  }
  @media screen and (max-width: 767px){
    .product_warp{

    }
    .el-tabs__header{
      margin: 0;
    }
    .el-tabs__nav{
      width: 100%;
      margin-top: -12px;
    }
    .el-tabs__item{
      height: 40px;
      line-height: 40px;
      width: 33.333%;
      text-align: center;
      background: #0b0b0b;
      opacity: 0.64;
      color: #fff;
      font-size: 0.32rem;
      padding: 0;
    }
    .el-tabs__item.is-active{
      background: #008cee;
      color: #fff;
      opacity: 1;
    }
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs__item:hover {
      color: #fff;
    }
    .product_banner_warp{
      overflow: hidden;
      margin-top:1.18rem;

    }
    .product_banner{
      vertical-align: middle;
      width: 100%;
    }
    /*背景色*/
    .bg_g{
      background-color: #fff;
    }
    .bg_g{
      background-color: rgb(247,247,247);
    }
    /*边看边买*/
    .look_bug{

    }
    .look_bug_item{
      width:100%;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 50px 0;
      text-align: center;
    }
    .look_bug_img{
      text-align: center;
    }
    .look_bug_img img{
      width: 90%;
      vertical-align: middle;
    }
    .look_bug_img video{
      width: 90%;
      vertical-align: middle;
    }
    .look_bug_text{
      display: flex;
      align-items: center;
    }
    .look_bug_text>div{
      width: 100%;
    }
    .look_bug_title{
      width: 90%;
      margin: 5px auto;
      font-size: 20px;
      font-weight: 500;

    }
    .look_bug_p{
      width: 90%;
      margin: 0 auto;
      line-height: 20px;
      font-size: 12px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/product2.vue